module.exports = __webpack_public_path__ + "static/3d-visual-3-2f8f2c3c08928cc4ff6731d655b74284.jpeg";